export default __webpack_public_path__ + "static/media/480_dummy2016-kuenstler02-de.3d98414d.png";